import { pascalCase } from 'pascal-case';

const asId = string => {
    return pascalCase(string);
};

export default asId;
